import { useTranslation } from "next-i18next"
import { DetailedHTMLProps, FormHTMLAttributes } from "react"
import { styled, VStack } from "styled-system/jsx"
import { ZodError } from "zod"

import * as s from "./ContactForm.css"

export type FormResponse = {
  message: string
  error?: boolean
  issues?: ZodError["issues"]
  data?: Record<string, any>
} | null

type Props = {
  data?: FormResponse
  fullWidth?: boolean
} & DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>

function FormWrapper({ data, fullWidth, children, ...props }: Props) {
  const { t } = useTranslation()

  const translate = key => t(`validation.${key}`, { defaultValue: key || "" })

  return (
    <VStack
      as="form"
      alignItems="stretch"
      gap={8}
      css={{
        rounded: "20px",
        background: "#F5F7FF",
      }}
      {...props}>
      <styled.div
        id="form"
        css={{
          position: "absolute",
          height: 0,
          transform: "translateY(-150px)",
        }}
      />
      {data &&
        (data.error ? (
          <div className={s.bad}>
            <p>{translate(data.message)}</p>
            <ul>
              {data?.data?.errors &&
                Object.entries(data.data.errors).map(([key, value]) => (
                  <li key={key}>
                    <>
                      [{t(key)}] {translate(value[0])}
                    </>
                  </li>
                ))}
              {data.issues?.map((x, i) => (
                <li key={i}>
                  <>
                    [{t(x.path[0])}] {translate(x.message)}
                  </>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className={s.good}>{translate(data.message)}</div>
        ))}
      {children}
    </VStack>
  )
}

export default FormWrapper
export type { Props as FormWrapperProps }
